import { useQuery, UseQueryResult } from '@tanstack/react-query'
import { AxiosError, AxiosResponse } from 'axios'
import { IError } from '@unfoldrtech/portal-mic'
import {
  EReportColumnHeader,
  EParamInventoryTypeGlobal,
  EReportingTimeWindow,
  EParamChannelTypeGlobal,
  IReportingAdGroupsTableResponse,
} from '@unfoldrtech/portal-mic/dist/src/models/core'

import { generateCorrelationId, getTimezone } from '../utils/helpers'
import {
  TDAAdGroupsPositionsReportTableFilters,
  TDAAdGroupsReportTableFilters,
  TDOOHAdGroupsReportTableFilters,
  TDOOHAdGroupsScreensReportTableFilters,
  TGenericAdGroupsCategoriesReportTableFilters,
  TGenericAdGroupsKeywordsReportTableFilters,
  TGenericAdGroupsReportTableFilters,
  TPPRetailerId,
  TSPAdGroupsReportTableFilters,
} from '../models/types'
import { coreAPIV3 } from '../services/coreAPIV3'

export default function useGetRetailerReportingAdGroupsTableV3({
  retailerId,
  advertiserId,
  campaignId,
  inventoryType,
  sortBy,
  timeWindow,
  startDate,
  endDate,
  sortOrder,
  tzZone,
  pageLimit,
  pageOffset,
  filterBy,
  filterOperation,
  filterValue,
  name,
  status,
  channelType,
  enabled = true,
  suspense = true,
}: {
  enabled?: boolean
  suspense?: boolean
} & (
  | TGenericAdGroupsReportTableFilters
  | TGenericAdGroupsCategoriesReportTableFilters
  | TGenericAdGroupsKeywordsReportTableFilters
  | TSPAdGroupsReportTableFilters
  | TDAAdGroupsReportTableFilters
  | TDAAdGroupsPositionsReportTableFilters
  | TDOOHAdGroupsReportTableFilters
  | TDOOHAdGroupsScreensReportTableFilters
) &
  TPPRetailerId): UseQueryResult<
  AxiosResponse<IReportingAdGroupsTableResponse>,
  AxiosError<IError>
> {
  const queryKeyName = `getRetailerReportingAdGroupsTable_${inventoryType}_${retailerId}_${advertiserId}`

  return useQuery(
    [
      queryKeyName,
      { start: startDate, end: endDate, inventoryType, campaignId },
    ],
    () => {
      return coreAPIV3.retailerReporting().getRetailerAdGroupsReportTableV3(
        retailerId,
        generateCorrelationId(),
        advertiserId,
        campaignId,
        inventoryType as EParamInventoryTypeGlobal,
        sortBy as EReportColumnHeader,
        sortOrder,
        timeWindow as EReportingTimeWindow,
        startDate,
        endDate,
        tzZone || getTimezone(),
        pageLimit,
        pageOffset,
        filterBy,
        filterOperation,
        filterValue,
        name,
        // @ts-expect-error: fix in PORT-2535
        status,
        channelType as EParamChannelTypeGlobal | undefined
      )
    },
    { suspense, enabled }
  )
}
